module.exports = __webpack_public_path__ + "static/media/bar-chart-24px.b91e3bfc.svg";